import { View } from '@aws-amplify/ui-react';
import SmartPortBranding from '../../SmartPortBranding';

export const Header = () => {
  return (
    <View className="authenticatorHeader">
      <SmartPortBranding />
    </View>
  );
}